import { ModalCustom } from "components/ModalCustom";
import {
  ContainerFooter,
  IconeTooltipServico,
  InputContainer,
  OptionContainer,
  RadioContainer,
} from "./style";
import { Col, Form, Row } from "react-bootstrap";
import { useEffect } from "react";
import { IDadosEmitirLicenciamento } from "../../Interfaces/IDadosEmitirLicenciamento";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { UF_OPTIONS } from "../../Constants";
import { CustomInput } from "components/CustomInput";
import { Required } from "components/Required";
import { PrimaryButton } from "components/Button/style";

interface Props {
  showModal: boolean;
  handleCloseModal: () => void;
  onSubmit: () => void;
  empresasOptions: IOptions[];
  defaultDadosEmitir: IDadosEmitirLicenciamento;
  setDadosEmitir: (dados: IDadosEmitirLicenciamento) => void;
  dadosEmitir: IDadosEmitirLicenciamento;
}

const anoAtual = new Date().getFullYear();

const opcoesAno = [
  { label: String(anoAtual), value: anoAtual },
  { label: String(anoAtual - 1), value: anoAtual - 1 },
];

export function ModalEmitirLicenciamento({
  showModal,
  handleCloseModal,
  onSubmit,
  empresasOptions,
  defaultDadosEmitir,
  setDadosEmitir,
  dadosEmitir,
}: Readonly<Props>) {
  useEffect(() => {
    if (showModal) {
      setDadosEmitir({ ...defaultDadosEmitir });
    }
  }, [showModal]);

  return (
    <ModalCustom
      show={showModal}
      handleClose={handleCloseModal}
      title="Emitir licenciamentos"
      centered
      footer
      footerTools={
        <ContainerFooter>
          {" "}
          <PrimaryButton
            onClick={handleCloseModal}
            outline={true}
            variante="primary"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            onClick={onSubmit}
            variante="primary"
            disabled={
              !dadosEmitir.exercicio ||
              !dadosEmitir.idEmpresa ||
              !dadosEmitir.uf
            }
          >
            Emitir
          </PrimaryButton>
        </ContainerFooter>
      }
    >
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>
              UF <Required />
            </Form.Label>
            <DropdownSelect
              options={UF_OPTIONS}
              selectedValue={dadosEmitir.uf}
              onSelect={(e) => setDadosEmitir({ ...dadosEmitir, uf: e })}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>
              Exercício <Required />
              <IconeTooltipServico title="UF de emplacamento" />
            </Form.Label>
            <DropdownSelect
              options={opcoesAno}
              selectedValue={dadosEmitir.exercicio}
              onSelect={(e) => setDadosEmitir({ ...dadosEmitir, exercicio: e })}
            />
          </Form.Group>
        </Col>
      </Row>
      <InputContainer>
        <Form.Group>
          <Form.Label>Descrição</Form.Label>
          <CustomInput
            type="text"
            placeholder="Informe a descrição"
            value={dadosEmitir.descricao}
            onChange={(e) =>
              setDadosEmitir({ ...dadosEmitir, descricao: e.target.value })
            }
          />
        </Form.Group>
      </InputContainer>
      <InputContainer>
        <Form.Group>
          <Form.Label>
            Empresa <Required />
          </Form.Label>
          <DropdownSelect
            options={empresasOptions}
            selectedValue={dadosEmitir.idEmpresa}
            onSelect={(e) => setDadosEmitir({ ...dadosEmitir, idEmpresa: e })}
            searchable
          />
        </Form.Group>
      </InputContainer>
      <RadioContainer>
        <Form.Group>
          <Form.Label>Gerar recibo de cobrança</Form.Label>
        </Form.Group>
        <OptionContainer
          onClick={() => setDadosEmitir({ ...dadosEmitir, cobrar: "SIM" })}
        >
          <input
            id="radioCobrarSim"
            type="radio"
            className="custom-radio"
            value="SIM"
            checked={dadosEmitir.cobrar === "SIM"}
            style={{ marginRight: 8 }}
          />
          <label htmlFor="radioCobrarSim">Sim</label>
        </OptionContainer>

        <OptionContainer
          onClick={() => setDadosEmitir({ ...dadosEmitir, cobrar: "NAO" })}
        >
          <input
            id="radioCobrarNao"
            type="radio"
            className="custom-radio"
            value="NAO"
            checked={dadosEmitir.cobrar === "NAO"}
            style={{ marginRight: 8 }}
          />
          <label htmlFor="radioCobrarNao">Não</label>
        </OptionContainer>
      </RadioContainer>
    </ModalCustom>
  );
}
